import apiClient from '@/apiClient';

import MaskedInput from 'vue-text-mask';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';

library.add(faSave);

export default {
  name: 'materials-table',

  props: {
    firmId: {
      type: Number,
      required: true
    },
    materialTypeId: {
      type: Number,
      required: true
    },
    materialGroupId: {
      type: Number,
      required: true
    },
    materialSubtypes: {
      type: Array,
      default: []
    },
    unit: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      rows: [],
      columns: [
        {
          label: 'Название материала',
          field: 'title'
        },
        {
          label: 'Вид',
          field: 'materialSubtypeId'
        },
        {
          label: 'Ед.',
          field: 'unit',
          thClass: 'vgt-table__cell--min-width'
        },
        {
          label: 'Цена за единицу',
          field: 'price',
          thClass: 'vgt-table__cell--min-width'
        },
        {
          label: 'Текстура',
          field: 'textureThumbnail',
          thClass: 'vgt-table__cell--min-width'
        },
        {
          label: 'Включен',
          field: 'isActive',
          thClass: 'vgt-table__cell--min-width'
        },
        {
          label: 'Действия',
          field: 'options',
          thClass: 'vgt-table__cell--min-width'
        }
      ],
      serverParams: {
        page: 1,
        perPage: 10
      },
      activeTexture: ''
    };
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    reset() {
      this.serverParams.page = 1;
      this.loadItems();
    },

    loadItems() {
      new Promise((resolve, reject) => {
        apiClient
          .get(
            `/firms/${this.firmId}/materials?page=${this.serverParams.page}&perPage=${this.serverParams.perPage}&materialTypeId=${this.materialTypeId}`
          )
          .then(response => {
            this.totalRecords = response.data.total;
            this.rows = response.data.data;
            response.data.data.forEach(material => {
              material.price = String(material.price);
            });
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    updateMaterial(id, payload) {
      return new Promise((resolve, reject) => {
        apiClient
          .put(`/constructors/materials/${id}`, payload)
          .then(resp => {
            this.flashSuccess('Информация о материале обновлена');
            resolve(resp);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },

    setMaterialActiveState(id, state) {
      const updatedMaterial = this.rows.find(item => item.id === id);
      updatedMaterial.isActive = state;
      return new Promise((resolve, reject) => {
        apiClient
          .put(`/constructors/materials/${id}`, {
            isActive: state
          })
          .then(resp => {
            if (state) {
              this.flashSuccess('Материал включен');
            } else {
              this.flashSuccess('Материал выключен');
            }
            resolve(resp);
          })
          .catch(err => {
            updatedMaterial.isActive = !state;
            if (err.response.status === 400) {
              this.flashError(
                'Как минимум, один материал каждого типа должен быть включён'
              );
            } else {
              this.flashError('Произошла ошибка при обновлении материала');
            }
            reject(err);
          });
      });
    },

    deleteMaterial(id) {
      return new Promise((resolve, reject) => {
        apiClient
          .delete(`/constructors/materials/${id}`)
          .then(resp => {
            this.flashSuccess('Материал удален');
            this.loadItems();
            resolve(resp);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },

    openTexturePopup(url) {
      this.activeTexture = url;
      this.$refs.texturePopup.open();
    },

    getMaterialSubtypeById(subtypeId) {
      const subtype = this.materialSubtypes.filter(
        subtype => subtype.id === subtypeId
      );
      return subtype.length > 0 ? subtype[0].title : '';
    }
  },

  mounted() {
    this.loadItems();
  },
  components: {
    FontAwesomeIcon,
    MaskedInput
  }
};
